<p class="mt-0">{{ 'sound_manager.message.not_delete_in_used' | translate }}</p>
<ul *ngIf="inUsedObjects['sipphone']" class="in-used-list">
    <strong>{{ 'phone_config_request.content.sipphone'|translate }}</strong>
    <li *ngFor="let sipphone of inUsedObjects['sipphone']">
        {{ sipphone.extension }}
    </li>
</ul>
